import { NavLink } from "react-router-dom";
import { styled } from "styled-components";

export const SidebarContainer = styled.aside`
  min-width: 230px;
  background-color: #F2F2F2;
  border-right: 1px solid #e0e0e0;
`;

export const Logo = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 15px 34px;
    font-size: 15px;
    font-weight: 700;

    background: rgb(72, 77, 90);
    color: white;
`;

export const NavItem = styled(NavLink)`
    display: block;
    padding: 0.85rem 1.85rem;
    font-size: 14px;
    font-weight: 400;

    color: rgb(0, 0, 0);
    text-decoration: none;
    transition: background-color 0.2s;

    &:hover {
        background: rgb(227, 227, 227);
        color: rgb(0, 0, 0);
        text-decoration: inherit;
    }

    &.active {
        background: rgb(227, 227, 227);
    }
`;
